// extracted by mini-css-extract-plugin
export default {"vehicleName":"VehicleInfo_vehicleName__803GX"};